module.exports = __webpack_public_path__ + "img/small-program-code.c8435a9c.png";